import React, { useState, useRef, useMemo, useEffect } from 'react';
import PropTypes from 'prop-types';
import { translate } from '@utils/i18n';
import { DropDownList } from '@progress/kendo-react-dropdowns';

const namespace = 'features.proposals.price_list_selector';

function PriceListSelector({ priceList, priceLists }) {
  const [priceListId, setPriceListId] = useState(priceList?.id ?? '');
  const [filterQuery, setFilterQuery] = useState('');
  const input = useRef();

  const onChange = (e) => {
    const newId = e.target.value.value;
    setPriceListId(newId);
  };

  useEffect(() => {
    input.current.dispatchEvent(new Event('change'));
  }, [priceListId]);

  const ddListValue = () => {
    if (priceListId === undefined || priceListId === null || priceListId === '') return null;

    // A proposal can reference a price list that is inactive, and `priceLists` only carries
    // active ones — so a valid id can still be absent here.
    const selected = priceLists.find((elem) => elem.value === priceListId);
    if (!selected) return null;

    return {
      value: priceListId,
      label: selected.label
    };
  };

  const onFilterChange = (event) => {
    setFilterQuery(event.filter.value);
  };

  const filteredPriceLists = useMemo(() => {
    if (filterQuery === '') return priceLists;

    const re = new RegExp(filterQuery, 'i');

    return priceLists.filter((list) => re.test(list.label));
  }, [filterQuery]);

  return (
    <div className="qmb-select" style={{ minWidth: '200px' }}>
      <label className="qmb-label">{translate('price_list', { namespace })}</label>
      <DropDownList
        required
        filterable
        onFilterChange={onFilterChange}
        id="priceListSelector"
        className="qmb-popup"
        textField="label"
        dataItemKey="value"
        data={filteredPriceLists}
        value={ddListValue()}
        onChange={onChange}
      />
      <input ref={input} type="hidden" name="proposal[price_list_id]" value={priceListId} />
    </div>
  );
}

PriceListSelector.propTypes = {
  priceList: PropTypes.object,
  priceLists: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.number,
      label: PropTypes.string
    })
  ).isRequired
};

PriceListSelector.defaultProps = {
  priceList: null
};

export default PriceListSelector;
